/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {CCXIStarterLibs} from '@ccxi/ccxi-starter-lib/src';
import {addToast, Toast} from '@react/react-spectrum/Toast';
import {getEnvironment} from '../../../utils/Environment';
import getConfig from '../../../config';
import appsUtils from '../../containers/Apps/AppsUtils';
import thorUtils from '../../../utils/ThorUtils';
import LibrariesAnalytics from '../../analytics/LibrariesAnalytics';
import './Libraries.scss';
import {WebStorage} from 'cchome-shared/utils';
import LibrariesUtil from '../../../utils/LibrariesUtil';
import SurveyPopup from 'cchome-shared/components/SurveyPopup/SurveyPopup';
import {surveyData} from './SurveyData';
import SurveyPopupAnalytics from '../../components/SurveyPopup/Analytics/SurveyPopupAnalytics';
import UserTypeUtil from '@cchome/home-components/src/components/PersonalizedHome/UserTypeUtil';
/* eslint-enable no-unused-vars */
export const librariesLocaleMap = {
	zh_HANS: 'zh_CN',
	/* eslint camelcase: ["error", {properties: "never"}] */
	zh_HANT: 'zh_TW',
	/* eslint camelcase: ["error", {properties: "never"}] */
};
interface State {
	isLibraryLoaded: boolean;
	showSurvey: boolean;
}

interface Props {
	planCode: any;
}

const updateTypes = {
	patchUpdate: 'PatchUpdate',
	fullBuildUpdate: 'FullBuildUpdate',
};

const MAX_LIB_2021 = 'temp_max_lib_2021_release';
class Libraries extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isLibraryLoaded: false,
			showSurvey: false,
		};
	}
	scrollEventCallback;

	componentDidMount() {
		this.hideJarvis();
		if (window.cchome.util.getLocale() === 'en_US') {
			// enable feedback component only for english locale
			const userClosedSurvey
				= window.cchome.util.storageAvailable('localStorage')
				&& localStorage.getItem(`closedSurveyPopup-libraries-${window.cchome.util.getUserId()}`);
			if (!userClosedSurvey) {
				this.scrollEventCallback = () => {
					const librariesEle = document.getElementsByClassName('cch-libraries-main')[0] as HTMLElement;
					if (librariesEle && window.innerHeight + window.pageYOffset >= librariesEle.offsetHeight) {
						this.setState({
							showSurvey: true,
						});
					}
				};
				// hiding the survey popup window.addEventListener('scroll', this.scrollEventCallback);
			}
		}
	}
	componentWillMount() {
		document.body.className += ' ' + 'cch-libraries-root';
	}

	componentWillUnmount() {
		document.body.className = document.body.className.replace('cch-libraries-root', '');
		this.scrollEventCallback && window.removeEventListener('scroll', this.scrollEventCallback);
		this.showJarvis();
	}

	hasFeature(feature: string) {
		return window.cchome && window.cchome.util && window.cchome.util.hasFeature && window.cchome.util.hasFeature(feature);
	}

	showJarvis() {
		document.body && document.body.classList.remove('hide-jarvis');
	}

	hideJarvis() {
		document.body && document.body.classList.add('hide-jarvis');
	}

	renderSurveyPopup() {
		const analyticsCallback = ({eventName, eventSubtype, contentName, contextGUID, eventValue, sortOrder}) => {
			const surveyPopupAnalytics = new SurveyPopupAnalytics();
			switch (eventName) {
				case 'render':
					surveyPopupAnalytics.postRender('Libraries');
					break;
				case 'click':
					surveyPopupAnalytics.postClickAction(
						eventSubtype,
						contentName,
						contextGUID,
						eventValue,
						sortOrder,
						'Libraries',
					);
			}
		};
		const surveyPopContext = {
			analyticsCallback,
			surveyData,
			title: 'libraries',
			localStorageGuid: window.cchome.util.getUserId(),
			localStorageAvailable: window.cchome.util.storageAvailable('localStorage'),
		};
		return <SurveyPopup surveyPopContext={surveyPopContext} />;
	}

	getInstalledProduct(bifrost, sapcode) {
		let product;
		if (sapcode && bifrost && bifrost.isConnected()) {
			const productsList = bifrost.getProductsList();
			product = productsList.installed.filter(
				ele => ele.sapcode && ele.sapcode.toUpperCase() === sapcode.toUpperCase(),
			)[0];
			if (!product) {
				const updatableProduct = productsList.available_updates.filter(
					ele => ele.sapcode && ele.sapcode.toUpperCase() === sapcode.toUpperCase(),
				)[0];
				if (
					updatableProduct
					&& (updatableProduct.update_type === updateTypes.fullBuildUpdate
						|| updatableProduct.update_type === updateTypes.patchUpdate)
				) {
					product = updatableProduct;
				}
			}
		}
		return product;
	}

	render() {
		const shouldEnableOpenInApp = planCode =>
			window.cchome.util.hasFeature('temp_enable_lib_open_in_app')
			&& !window.cchome.util.isMobileOrTabletBrowser()
			&& !UserTypeUtil.isFree(planCode);
		const appContext = {
			isLoggedOutMode: false,
			isMax2021: this.hasFeature(MAX_LIB_2021),
			useAEM: true,
			getIMSData: () => {
				const imsData: any = appsUtils.getIMSData();
				const {token, email, userId} = imsData;

				return {
					getToken: () => token,
					getUserEmail: () => email,
					getUserId: () => userId,
					// eslint-disable-next-line camelcase
					getSubscriptionType: () => window.adobeIMS.getUserProfile()?.account_type,
				};
			},
			componentsToRender: {
				sideNav: false,
				rightPanel: {
					header: false,
					banner: !this.hasFeature(MAX_LIB_2021),
					grid: true,
					info: true,
					followedCTA: true,
					leanMoreInToast: true,
					heroBanner: this.hasFeature(MAX_LIB_2021),
					openInAppCTA: shouldEnableOpenInApp(this.props.planCode),
				},
			},
			getEnvironment() {
				return getEnvironment() === 'prod' ? 'prod' : 'stage';
			},

			getAPIKey() {
				return getConfig('CLIENT_ID');
			},

			getLocale() {
				const locale = window.cchome.util.getLocale();
				return librariesLocaleMap[locale] || locale;
			},

			routeToLibraries() {
				window.open('https://assets-stage.adobecc.com/libraries');
			},

			routeToLibrary(libraryId, {url, guid}) {
				const extUrl = LibrariesUtil.getExternalLink(url, guid);
				window.open(extUrl);
			},

			routeToLearnMore({url, guid}) {
				const extUrl = LibrariesUtil.getExternalLink(url, guid);
				window.open(extUrl);
			},

			showToast(message, props) {
				addToast(
					<Toast closable {...props}>
						{message}
					</Toast>,
				);
			},
			handleAnalytics(analyticsObj) {
				const librariesAnalytics = new LibrariesAnalytics();
				librariesAnalytics.sendLibrariesAnalytics(analyticsObj);
			},
			registerCallbacks() {},
			onLoadComplete: () => {
				this.setState({isLibraryLoaded: true});
			},
			checkAppInstallStatus: (sapcode) => {
				let product;
				const bifrost = thorUtils.getWamClient();
				if (!bifrost) {
					return false;
				}
				// check the installed status of the product.
				// use bifrost to check the status of the product.
				if (bifrost.isConnected()) {
					// Use latest build of bifrost
					product = this.getInstalledProduct(bifrost, sapcode);
				}
				return typeof product !== 'undefined';
			},
			handleOpenInAppActions: (sapcode, isInstalled) => {
				const bifrost = thorUtils.getWamClient();
				// launch the product if it is installed.
				// use bifrost to launch the product.
				if (bifrost && bifrost.isConnected() && isInstalled) {
					setTimeout(() => {
						// Use latest build of bifrost
						const product = this.getInstalledProduct(bifrost, sapcode);
						if (product) {
							bifrost.sendCommand({
								sapCode: product.sapcode,
								version: product.version,
								commandPayload: {
									command: 'launch',
								},
							});
						}
					}, 8000);
					return;
				}

				if (!isInstalled) {
					window.open(`/apps?sapcode=${sapcode}&action=install`, '_blank');
				}
			},
			loadAction: {},
		};
		/* eslint-disable */
		const webStorage = new WebStorage();
		const libraryIdInReq = webStorage.get('libraryId');
		const action = webStorage.get('action');
		if (action && libraryIdInReq) {
			appContext.loadAction = {
				action,
				libraryIdInReq,
			};
			webStorage.remove('libraryId');
			webStorage.remove('action');
			const analyticsObj = {
				'event.type': 'render',
				'event.subtype': 'login-complete',
				'event.value': 'follow',
				'content.id': libraryIdInReq,
			};
			const librariesAnalytics = new LibrariesAnalytics();
			librariesAnalytics.sendLibrariesAnalytics(analyticsObj);
		}
		const className = `cch-libraries-main${this.state.isLibraryLoaded ? '' : ' cch-libraries-wait'}`;
		return (
			<div className={className}>
				<CCXIStarterLibs appContext={appContext} />
				{this.state.showSurvey && this.renderSurveyPopup()}
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		planCode: state.profile.subscriptionInfo.planCode,
	};
}
export default {
	component: connect(mapStateToProps, {})(Libraries),
};
